import { render } from "./discount-list.vue?vue&type=template&id=577b15e5"
import script from "./discount-list.vue?vue&type=script&lang=js"
export * from "./discount-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__